import React, { useEffect, useState } from 'react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/autoplay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Image from 'next/image';
import Link from 'next/link';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import SectionHeading from '../Common/SectionHeading';


const MeetSpecialist = ({ data, title = "" }) => {

  const [slidesPerView, setSlidesPerView] = useState(2);

  useEffect(() => {
    const handleResize = () => {
      setSlidesPerView(window.innerWidth >= 768 ? 2 : 1);
    };

    // Initial setup
    handleResize();

    // Attach resize event listener
    window.addEventListener('resize', handleResize);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  return (
    <>
      <div className="flex flex-col justify-center w-11/12 mx-auto my-4 xl:max-w-screen max-w-screen-2xl lg:my-8">
        {title && 
          <SectionHeading 
          title={title}
          
          customClass="text-center"
        />}
        <div className="grid grid-cols-12 gap-4">
         
            {data?.map((item, index) => (
              <div key={index} className="col-span-12 md:col-span-6 lg:col-span-6">
                <div className="relative">
                  <div className="overflow-hidden bg-white rounded shadow-md dark:bg-gray-600 mt-28">
                    <div className="absolute flex justify-center w-full -mt-20">
                      <div className="w-32 h-32">
                        <Image priority={false}
                          height={2000}
                          width={2000}
                          src={process.env.IMG_CDN+item?.imageSrc}
                          alt={item?.name}
                          className="object-cover w-full h-full border rounded-full shadow-md"
                        />

                      </div>
                    </div>
                    <div className="w-full h-full px-4 mt-16 lg:px-7">
                      <h3 className="mb-0 text-lg font-semibold text-center">{item?.name}</h3>
                      <p className="text-[#1b5df3] text-sm text-center my-0 md:line-clamp-1">{item?.designation}</p>
                      <p className="my-1 text-sm font-normal text-black dark:text-white">
                        {item?.description}
                      </p>
                      <div className="flex justify-center w-full pb-4">
                        <Link href={item?.linkedin} target='_blank' className='rounded-full text-[#1b5df3] px-3 py-1.5 m-1 text-lg border-solid border-gray-700 bg-slate-100 dark:bg-gray-700 hover:bg-[#0073b1] hover:dark:bg-[#0073b1] hover:text-white'>
                          <FontAwesomeIcon className='p-0 m-0 text-md' icon={faLinkedin} size="lg" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default MeetSpecialist;
